import { useAuth } from "../../hooks/useAuth";
import { Building2, Users, Calendar, Activity } from "lucide-react";

const TenantDashboard = () => {
    const { user, tenant } = useAuth();

    const stats = [
        { label: "Total Patients", value: "0", icon: <Users className="h-6 w-6" />, color: "bg-blue-500" },
        { label: "Appointments", value: "0", icon: <Calendar className="h-6 w-6" />, color: "bg-green-500" },
        { label: "Active Doctors", value: "0", icon: <Activity className="h-6 w-6" />, color: "bg-purple-500" },
    ];

    return (
        <div className="space-y-8">
            <div>
                <h1 className="text-3xl font-bold text-gray-900">
                    Welcome to {tenant?.hospitalName || "Hospital Portal"}
                </h1>
                <p className="text-gray-500 mt-2">
                    Hello, {user?.name}. You are logged in as a {user?.role}.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {stats.map((stat, index) => (
                    <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
                        <div className={`${stat.color} p-3 rounded-lg text-white`}>
                            {stat.icon}
                        </div>
                        <div>
                            <p className="text-sm text-gray-500 font-medium">{stat.label}</p>
                            <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center justify-center text-center space-y-4">
                <div className="h-16 w-16 bg-primary-50 rounded-full flex items-center justify-center">
                    <Building2 className="h-8 w-8 text-primary-600" />
                </div>
                <div>
                    <h2 className="text-xl font-bold text-gray-900">Precision Care Initialized</h2>
                    <p className="text-gray-500 max-w-md mx-auto mt-2">
                        Your hospital infrastructure is ready. You can now start adding doctors and managing patients.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TenantDashboard;
